import { render, staticRenderFns } from "./CollectDetailComponent.vue?vue&type=template&id=1a1a4ff1&scoped=true&"
import script from "./CollectDetailComponent.vue?vue&type=script&lang=js&"
export * from "./CollectDetailComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a1a4ff1",
  null
  
)

export default component.exports